<template>
  <modal  width="80%" :minHeight="800" height="auto"
         name="quote-modal" ref="quote-modal" id="cart-center-lockerroom" size="xl" class="quote-modal absolute-modals" modal-class="modal-fullscreen2"
         content-class="lockerroom-modal" >
    <div class="modal-header d-flex justify-content-between">
      <span class="fs-5 font-weight-bold">Accept Quote </span>
      <span class="fs-5 font-weight-bold cursor-pointer modal-close" @click="$modal.hide('quote-modal');">
        <BIconX />
      </span>
    </div>

    <div style="height: calc(100vh - 300px); padding-bottom: 20px; overflow: hidden; overflow-y: auto;" class="theme-scroll-v">

      <b-form @submit.prevent="acceptQuote">
      <div class="p-3 grid grid-2 gap-2 text-left">
        <div class="well border-0" style="background: #f5f5f5">
          <div class="fs-2 font-weight-bold px-2 pt-1 pb-2">
            Shipping Address
          </div>
          <b-input-group  prepend="Select Address :">
            <b-form-select v-model="shipping_address"  :options="shipping_address_options"></b-form-select>
          </b-input-group>
          <template v-if="shipping_address">
            <div class="px-2 pt-1 pb-2">
              <div>{{ shipping_address.first_name + ' ' + shipping_address.last_name }}</div>
              <div v-if="shipping_address.email">{{ shipping_address.email }}</div>
              <div v-if="shipping_address.phone_number">{{ shipping_address.phone_number }}</div>
              <div v-if="shipping_address.company_name">{{ shipping_address.company_name }}</div>
              <div v-if="shipping_address.address1">{{ shipping_address.address1 }}</div>
              <div v-if="shipping_address.address2">{{ shipping_address.address2 }}</div>
              <div>
                <span v-if="shipping_address.city">{{ shipping_address.city }}</span>
                <span v-if="shipping_address.city">{{ ' ' }}</span>
                <span v-if="shipping_address.state">{{ shipping_address.state }}</span>
                <span v-if="shipping_address.state">{{ ' ' }}</span>
                <span v-if="shipping_address.zip_code">{{ shipping_address.zip_code }}</span>
                <span v-if="shipping_address.zip_code">{{ ' ' }}</span>
              </div>
              <div class="d-flex flex-wrap w-100">
                <div>{{ shipping_address.country.name }}</div>
              </div>

            </div>
          </template>
          <div v-else class="px-2 pt-1 pb-2">

            <div class="grid grid-mobile-2 gap-x-3 gap-y-1">
              <b-form-group label="First Name *" label-for="first_name" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.first_name"
                    placeholder="First Name"
                    name="first_name"
                    v-validate="'required'"
                ></b-form-input>
                <div v-if="errors && errors.first('first_name')" class="error_msg">
                  {{errors.first('first_name')}}
                </div>
              </b-form-group>

              <b-form-group label="Last Name *" label-for="last_name" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.last_name"
                    placeholder="Last Name"
                    name="last_name"
                    v-validate="'required'"
                ></b-form-input>
                <div v-if="errors && errors.first('last_name')" class="error_msg">
                  {{errors.first('last_name')}}
                </div>
              </b-form-group>

              <b-form-group label="Email" label-for="email" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.email"
                    placeholder="Email"
                    name="email"
                    v-validate="'email'"
                ></b-form-input>
                <div v-if="errors && errors.first('email')" class="error_msg">
                  {{errors.first('email')}}
                </div>
              </b-form-group>

              <b-form-group label="Phone Number *" label-for="phone_number" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.phone_number"
                    placeholder="Phone Number"
                    name="phone_number"
                    v-validate="'required|numeric'"
                ></b-form-input>
                <div v-if="errors && errors.first('phone_number')" class="error_msg">
                  {{errors.first('phone_number')}}
                </div>
              </b-form-group>
            </div>

            <div class="grid grid-2 gap-x-3 gap-y-1">
              <b-form-group label="Address *" label-for="address1" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.address1"
                    placeholder="Address"
                    name="address1"
                    v-validate="'required'"
                ></b-form-input>
                <div v-if="errors && errors.first('address1')" class="error_msg">
                  This field is required.
                </div>
              </b-form-group>

              <b-form-group label="Second Address" label-for="address2" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.address2"
                    placeholder="Second Address"
                    name="address2"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="grid grid-mobile-2 gap-x-3 gap-y-1">
              <b-form-group label="City *" label-for="city" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.city"
                    placeholder="City"
                    name="city"
                    v-validate="'required'"
                ></b-form-input>
                <div v-if="errors && errors.first('city')" class="error_msg">
                  {{errors.first('city')}}
                </div>
              </b-form-group>

              <b-form-group label="Zip Code *" label-for="zip_code" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.zip_code"
                    placeholder="Zip Code"
                    name="zip_code"
                    v-validate="'required|max:100'"
                ></b-form-input>
                <div v-if="errors && errors.first('zip_code')" class="error_msg">
                  {{errors.first('zip_code')}}
                </div>
              </b-form-group>

              <b-form-group label="Country *" label-for="country" class="text-left">
                <b-form-select
                    v-model="shipping_address_form.country"
                    :options="countries"
                    class="mb-3"
                    value-field="id"
                    text-field="name"
                    name="country"
                    v-validate="'required'"
                ></b-form-select>
                <div v-if="errors && errors.first('country')" class="error_msg">
                  This field is required.
                </div>
              </b-form-group>

              <b-form-group label="Company Name" label-for="company_name" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.company_name"
                    placeholder="Company Name"
                    name="company_name"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="State/Province" label-for="state" class="text-left">
                <b-form-input
                    type="text"
                    v-model="shipping_address_form.state"
                    placeholder="State/Province"
                    name="state"
                ></b-form-input>
              </b-form-group>
            </div>


          </div>
        </div>

        <div class="align-self-start" style="max-width: 100%">
          <div class="fs-2 font-weight-bold mt-3">General comments</div>
          <div class="mt-1">
            <b-form-input class="form-input" placeholder="Any comments?" type="text" name="general_comments"
                          v-model="general_comments" />
          </div>
          <div class="fs-2 font-weight-bold mt-3"><span class="text-danger">*</span> Team Name / order reference</div>
          <div class="mt-1">
            <b-form-input class="form-input" placeholder="Team Name / order reference" type="text"
                          name="customer_reference_no"
                          v-model="customer_reference_no"
                          v-validate="'required'"
            />
          </div>
          <div v-if="errors && errors.first('customer_reference_no')" class="error_msg">
            This field is required.
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button style="margin-right: 15px" class="mt-4" type="submit">Accept</b-button>
      </div>
      </b-form>
    </div>
  </modal>
</template>

<script>
import {http} from "@/config/httpCommon";


export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      customer_reference_no: "",
      general_comments: "",
      shipping_address: null,
      shipping_address_options: [
        { value: null, text: 'Add new address' }
      ],
      shipping_address_id: null,
      shipping_address_form : {
        first_name: '',
        last_name: '',
        email: '',
        address1: '',
        address2: '',
        phone_number: '',
        city:'',
        company_name: '',
        state:'',
        zip_code:'',
        country:59,
        default:false
      },
      countries: []
    };
  },
  computed: {
    company() {
      return this.$store.getters.getCompany;
    },
    isCustomerAuthenticated() {
      return this.$store.getters.isCustomerAuthenticated;
    }
  },
  watch: {
    order: {
      immediate: true,
      deep: true,
      handler() {
        this.initializeData();
      }
    }
  },
  methods: {
    initializeData() {
      if (this.order) {
        this.customer_reference_no = this.order.customer_reference_no || '';
        this.general_comments = this.order.general_comments || '';
        this.getCustomerAddresses();
        if(this.countries.length < 1) {
          this.getCountries();
        }
      }
    },
    async acceptQuote() {
      let valid = await this.$validator.validate();
      if(valid){
        let payload = {
          order_id: this.order.id,
          customer_reference_no: this.customer_reference_no,
          general_comments: this.general_comments,
          shipping_address: this.shipping_address_form
        };

        if (this.shipping_address) {
          payload['address_id'] = this.shipping_address.id;
        }

        this.$store.commit('set', ['showLoader', true]);

        http.post('accept-quote-order', payload).then((response) => {
          if (response.data.success) {
            this.$store.dispatch('addToCart', []);
            this.showToast(response.data.message, 'SUCCESS');
            this.$store.commit('set', ['showLoader', false]);
            this.$modal.hide('quote-modal');
            this.$emit('call-order-detail');
          } else {
            this.$store.commit('set', ['showLoader', false]);
            this.showToast('Your order could not be created', 'Error');
          }
        }).catch((err) => {
          this.$store.commit('set', ['showLoader', false]);
          this.showToast('Order not generated', 'Error')
        });
      }

    },
    async getCustomerAddresses() {
      this.$store.commit('set', ['showLoader', true]);
      http.post('get-customer-addresses', {customer_id:this.order.customer_id}).then((res) => {

        if(res.data.result.length > 0) {
          this.shipping_address_options = [
            { value: null, text: 'Add new address' }
          ]
          res.data.result.forEach((obj) => {
            this.shipping_address_options.push({value: obj, text: obj.first_name+ ' '+ obj.last_name+ ' '+obj.address1})
            if(obj.default) {
              this.shipping_address = obj;
            }
          })
        }
        this.$store.commit('set', ['showLoader', false]);
      }).catch((err) => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast(err.response.data.errors, 'Error');
      });

    },
     getCountries() {
        http.get(`/addresses/countries`).then((response) => {
          this.countries = response.data.result
        })
        .catch((e) => {
          this.showToast('Error in fetching countries', 'Error')
        });
    },
    hide() {
      this.$modal.hide('quote-modal');
    }
  }
};
</script>

<style scoped>
.highlightMOQ {
  background: #FF4500;
  color: #ffffff;
}

.loader {
&.relative {
   position: absolute;
   left: 0;
   right: 0;
   top: 0;
   bottom: 0;
   z-index: 1070;
   height: 100%;
   width: 100%;
   background: rgba(255, 255, 255, 0.9);
   padding: 20px;
 }
&.global {
   position: fixed;
   left: 0;
   right: 0;
   top: 0;
   bottom: 0;
   z-index: 99999;
   height: 100%;
   width: 100%;
   background: rgba(255, 255, 255, 1);
 }

img {
  max-width: 7%;
  display: block;
  margin: 0 auto;
  height: auto;
}
}
</style>
